import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import Select from "react-select";

const SectionBoardDialog = ({
  group,
  tableManager,
  boardIdentifiers,
  updateSectionProperties,
  mutateCurrentRoom,
  setCurrentTab,
}) => {
  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {boardIdentifiers.map((identifier, index) => {
          const property = group.property_list.find(
            (e) => e.identifier === identifier
          );

          return (
            <div key={identifier} onClick={(e) => e.stopPropagation()}>
              {property && (
                <>
                  <p className="grey_letter mb-1">{property.name}</p>
                  {property.is_editable ? (
                    <Select
                      autoFocus={index === 0 ? true : false}
                      className="list-summary-select"
                      key={index}
                      value={
                        property.options.find((option) => option.selected) ||
                        null
                      }
                      isDisabled={!property.is_editable}
                      onChange={(selectedOption) => {
                        if (selectedOption.identifier === "__add_more__") {
                          if (setCurrentTab) {
                            setCurrentTab("materials", "boards");
                          } else {
                            tableManager.clear();
                          }
                          return;
                        }
                        property.options.forEach((o) => {
                          o.selected =
                            o.identifier == selectedOption.identifier;
                        });
                        mutateCurrentRoom();
                        updateSectionProperties({
                          id: group.id,
                          propIdentifier: property.identifier,
                          optionIdentifier: selectedOption.identifier,
                        });
                      }}
                      options={[
                        ...property.options.map((option, optionIndex) => {
                          option.value = option.name;
                          option.label = option.name;
                          option.key = index;
                          return {
                            value: option.name,
                            label: option.name,
                            ...option,
                          };
                        }),
                        ...(boardIdentifiers.some((id) =>
                          group.property_list.some(
                            (e) => e.identifier === id && e.is_editable
                          )
                        ) ? [                        {
                          value: "... add more boards",
                          label: "... add more boards",
                          identifier: "__add_more__",
                          key: `add-more-${index}`,
                        }] : [])
                      ]}
                    />
                  ) : (
                    <div className="mt-1 text-disabled">
                      {property.options.find((option) => option.selected)
                        ?.name || "No Value"}
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
      <TableDialogFooter>
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
          className="mt-3"
        >
          Done
        </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default SectionBoardDialog;
